import { Settings, Database, Zap, TrendingUp } from "lucide-react";
import { NichePage } from "./NichePageTemplate";

const sections = [
  {
    icon: Settings,
    name: "Operations",
    items: [
      "Process organization", "Administrative coordination", "Project management",
      "Research", "Documentation"
    ]
  },
  {
    icon: Database,
    name: "Systems",
    items: [
      "CRM organization", "Process mapping", "Workflow design",
      "System implementation", "Integration"
    ]
  },
  {
    icon: Zap,
    name: "Automation",
    items: [
      "Workflow automation", "Task automation", "Notifications",
      "Integrations", "Repetitive-process reduction"
    ]
  },
  {
    icon: TrendingUp,
    name: "Process Improvement",
    items: [
      "Identify bottlenecks", "Improve workflows", "Reduce manual work",
      "Organize information", "Establish repeatable processes"
    ]
  }
];

export const BusinessOperationsPage = () => (
  <NichePage
    title="Business Operations & Systems"
    subtitle="Operational structure, connected systems, and efficient workflows."
    sections={sections}
  />
);
